import { render } from "./DropDownList.vue?vue&type=template&id=2cce3dcc&bindings={\"data\":\"props\",\"val\":\"props\",\"idVal\":\"props\",\"nameVal\":\"props\",\"classVal\":\"props\",\"showDefault\":\"props\",\"useChangeFunction\":\"props\",\"lang\":\"data\",\"language\":\"setup\",\"onChangeSelect\":\"options\",\"onChangeFunction\":\"options\",\"checkForDisabled\":\"options\"}"
import script from "./DropDownList.vue?vue&type=script&lang=js"
export * from "./DropDownList.vue?vue&type=script&lang=js"

import "./DropDownList.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script